import { FormlyFieldConfig } from '@ngx-formly/core';

export class FormUtilities {
  /** Returns the input string formatted as Title Case. */
  public static findFieldByKey = (
    fields: FormlyFieldConfig[],
    targetKey: string
  ): FormlyFieldConfig => {
    for (let field of fields) {
      if (field.key === targetKey) {
        return field;
      }

      if (field.fieldGroup) {
        const result = this.findFieldByKey(field.fieldGroup, targetKey);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  };
}
